import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm, FormControl, Validators  } from '@angular/forms';
import { EqualValidator } from '@app/directives/equal-validator.directive';
import { OldPasswordValidatorDirective } from '@app/directives/oldpwd-equal-validator.directive';
import { ChangePasswordModel } from '@app/models/changepasswordmodel';
import { Router,ActivatedRoute } from '@angular/router';
import { ChangePassService } from '@app/services/authentication/change-pass.service';
import { ToastrService } from 'ngx-toastr';
import { ApiResponse } from '@app/models/OTPResult';



@Component({
    selector: 'change-password',
    templateUrl: './change-password.component.html'
    
})
export class ChangePasswordComponent implements OnInit {
    @ViewChild (NgForm) UserForm:NgForm;
    changePasswordInfo : ChangePasswordModel= new ChangePasswordModel();
    retypePassword  : string; 
    passwordChangeResult =new ApiResponse();
    constructor(private router : Router,
                private changePassService: ChangePassService,
                private toastyService: ToastrService)
    {  }
    
    ngOnInit() 
    {  }

    changedPassword() {
        
        this.changePassService.putPasswordChange(this.changePasswordInfo)
        .subscribe(
            data => {
            const result = JSON.parse(JSON.stringify(data));
            if(this.passwordChangeResult != undefined && this.passwordChangeResult.Status != false)
            {
                this.toastyService.success(this.passwordChangeResult.SuccessMessage);
            }
            else
            {
              this.toastyService.error(this.passwordChangeResult.ErrorMessage);
            }
        });
    }

    ResetFields()
    {
   this.UserForm.resetForm();
    }

    Cancel()
    {
        this.router.navigate(['dashboard']);
    }
   }



// WEBPACK FOOTER //
// ./src/app/components/customer-login/change-password.component.ts